import { Box } from "@mui/material";
import { UserLayout } from "../UserLayout";
import {
  DashboardActivityDetailSection,
  DashboardActivityHeaderSection,
} from "../../../modules";

export const DashboardActivity = () => {
  return (
    <UserLayout>
      <Box paddingTop="1rem">
        <DashboardActivityHeaderSection />
      </Box>
      <DashboardActivityDetailSection />
    </UserLayout>
  );
};
